<lottie-player src="./../assets/animations/email.json" background="transparent" speed="1" loop autoplay
  style="width: 400px; height: 400px">
</lottie-player>
